/**
 * Builds the list of equipment master document ids for multiselects when editing
 * facility consumption. API rows may use different shapes (populated ref, subdoc, or id string).
 */
export function facilityEquipmentIds(selectedData) {
  const raw = selectedData?.equipment;
  if (raw == null) return [];

  const list = Array.isArray(raw) ? raw : [raw];

  const ids = list.map((item) => {
    if (item == null) return null;
    if (typeof item === "string") return item;
    if (typeof item !== "object") return null;

    const nested = item.equipment;
    if (nested && typeof nested === "object" && nested._id != null) {
      return String(nested._id);
    }
    if (item._id != null) {
      return String(item._id);
    }
    return null;
  });

  return [...new Set(ids.filter(Boolean))];
}
